import { EmployeeTypeEnum } from "../constants/employeeType";
export const employeeTypeOptions = [
  { label: "Regular", value: EmployeeTypeEnum.REGULAR },
  { label: "Consultant", value: EmployeeTypeEnum.CONSULTANT },
  { label: "IVYClinic", value: EmployeeTypeEnum.IVYCLINIC },
  { label: "SQELabs", value: EmployeeTypeEnum.SQELABS },
];
